import { VSpacer } from 'vuetify/lib'
import { DATE_FIELD } from '../type_name'
import { DAY_FORMATE } from '../constants'
export default {
    name: DATE_FIELD,
    props: {
        field: {
            type: Object,
        },
        value: {
            type: Object
        }
    },
    methods: {
        // 生成 VSpacer
        setVSpacer(h) {
            if (this.vSpacer) {
                return this.vSpacer
            }
            return this.vSpacer = h(VSpacer)
        }
    },
    render(h) {
        const { 
             label,
             key, 
             textRender,
             initText = '-',
             formate = DAY_FORMATE
            } = this.field
        let text = initText
        if (textRender) {
            text = textRender({field:this.field, value:this.value})
        } else if (this.value[key]) {
            text = moment(this.value[key]).format(formate)
        } 
        return h('div', {
            style: {
                width: '100%',
                display: 'flex'
            }
        }, [
            h('span', {
                style:{
                    'white-space':'nowrap',
                    'margin-right': '10px'
                }
            }, label),
            this.setVSpacer(h),
            text
        ])
    }
}